(() => {
  const init = (root) => {
    if (!root || root.dataset.fhFooterReady === 'true') return;
    root.dataset.fhFooterReady = 'true';
    const defaultOpen = root.dataset.defaultOpen;
    root.querySelectorAll('[data-fh-accordion]').forEach((item) => {
      const button = item.querySelector('.fh-footer__accordion-button');
      const open = item.dataset.fhAccordion === defaultOpen;
      item.classList.toggle('is-open', open);
      button?.setAttribute('aria-expanded', String(open));
      button?.addEventListener('click', () => {
        const next = !item.classList.contains('is-open');
        item.classList.toggle('is-open', next);
        button.setAttribute('aria-expanded', String(next));
      });
    });
    root.querySelectorAll('[data-fh-localization-select]').forEach((select) => select.addEventListener('change', () => select.form?.submit()));
    root.classList.add('is-ready');
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-fh-footer]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();